import ListWithSubheaderDemoCode from "!!raw-loader!./menus/MenuListWithSubheaderDemo";
import ButtonMenuDemoCode from "!!raw-loader!./menus/ButtonMenuDemo";
import React from "react";
import { ComponentProps } from "../Component";
import Pane, { paneComponent, PaneProps } from "../Pane";
import MenuListWithSubheaderDemo from "./menus/MenuListWithSubheaderDemo";
import ButtonMenuDemo from "./menus/ButtonMenuDemo";

export default (props: PaneProps) => {
	const components: ComponentProps[] = [
		paneComponent("MoreHorizMenu With Subheader", ListWithSubheaderDemoCode, MenuListWithSubheaderDemo),
		paneComponent("ButtonMenu", ButtonMenuDemoCode, ButtonMenuDemo),
	];

	return (
		<Pane
			components={components}
			imports='import {ButtonMenu, ListWithSubheader, MoreHorizMenu} from "designSystem/index";'
			muiApi="list"
			muiComponent="lists"
			{...props}
		/>
	);
};